import { axiosPortalInstance } from '@mais-retorno-front/configs/axios-config';

export const getSponsoredSheet = async ({
  cnpj,
}: GetSponsoredSheetInput): Promise<GetSponsoredSheetOutput> => {
  try {
    const { data } = await axiosPortalInstance({
      method: 'POST',
      data: {
        query: `
           {
            laminaPatrocinada(cnpj: "${cnpj as string}")  {
              data {
                attributes {
                  contact_cta
                  video_youtube_id
                  asset_manager_website
                  asset_manager_email
                  asset_manager_phone
                  fund_description
                  brokers {
                    label
                    link
                  }
                  monthly_report {
                    data {
                      attributes {
                        url
                      }
                    }
                  }
                  video {
                    data {
                      attributes {
                        url
                      }
                    }
                  }
                  fund_description_document {
                    data {
                      attributes {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      },
    });

    const {
      brokers,
      monthly_report,
      video,
      fund_description_document,
      ...rest
    } = data?.data?.laminaPatrocinada?.data?.attributes || {};

    return {
      investmentList: brokers,
      monthly_report: monthly_report?.data?.[0]?.attributes?.url,
      video: video?.data?.attributes?.url,
      fund_description_document:
        fund_description_document?.data?.attributes?.url,
      isSponsored: !!data?.data?.laminaPatrocinada?.data,
      ...rest,
    };
  } catch (err) {
    return null;
  }
};

export const getSponsoredAssetManagerSheet = async (
  slug: string
): Promise<GetSponsoredSheetAssetManagerOutput> => {
  try {
    const { data } = await axiosPortalInstance({
      method: 'POST',
      data: {
        query: `
           {
            gestoraPatrocinadas(filters:{slug: {eq: "${slug}"}}) {
              data {
                attributes {
                  contact_cta
                  disable
                  linkedin
                  instagram
                  site
                  headline
                  about
                  highlight_fund_1
                  highlight_fund_2
                  highlight_fund_3
                  profile_image {
                    data{
                      attributes {
                        url
                      }
                    }
                  }
                  banner_image {
                    data{
                      attributes {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      },
    });

    const sponsored = data?.data?.gestoraPatrocinadas?.data?.[0]?.attributes;

    if (!sponsored) return null;
    if (sponsored.disable) return null;

    return {
      ...sponsored,
      profile_image: sponsored?.profile_image?.data?.attributes?.url,
      banner_image: sponsored?.banner_image?.data?.attributes?.url,
    };
  } catch (err) {
    console.log(err?.response?.data);

    return null;
  }
};

interface GetSponsoredSheetInput {
  cnpj: string;
}

interface InvestmentList {
  label: string;
  link: string;
}

interface GetSponsoredSheetOutput {
  investmentList: InvestmentList[] | null;
  monthly_report: string | null;
  video: string | null;
  video_youtube_id: string | null;
  isSponsored: boolean;
  fund_description_document: string | null;
  fund_description: string | null;
  contact_cta: string | null;
  asset_manager_website: string | null;
  asset_manager_email: string | null;
  asset_manager_phone: string | null;
}

interface GetSponsoredSheetAssetManagerOutput {
  disable: boolean;
  contact_cta: string | null;
  linkedin: string | null;
  instagram: string | null;
  site: string | null;
  headline: string | null;
  about: string | null;
  highlight_fund_1: string | null;
  highlight_fund_2: string | null;
  highlight_fund_3: string | null;
  profile_image: string | null;
  banner_image: string | null;
}
